import { LeftContainer } from "./LeftContainer";
import { NavContainer } from "./NavContainer";
import { NavGroup } from "./NavGroup";
import { NavItem } from "./NavItem";
import { RightContainer } from "./RightContainer";
import { Root } from "./Root";
import { TitleItem } from "./TitleItem";

export const navLinkStyles = {
  className:
    "block py-2 px-3 text-sm leading-5 normal-case bg-transparent rounded-md transition-colors duration-200 cursor-pointer select-none text-default hover:text-dark focus:text-dark",
  activeClassName: "!bg-tertiary !font-medium !text-dark",
};

export const HeaderNav = Object.assign(Root, {
  NavItem,
  NavGroup,
  NavContainer,
  TitleItem,
  LeftContainer,
  RightContainer,
});
